<div viewEdit="initialState" #viewEdit="viewEdit">
    <div class="view view-edit-show">
        <div style="display:flex;flex-direction: row;">
            <h6 style="flex:2">
                Status
            </h6>
            <div style="flex:1;display:flex;justify-content:end">
                <nb-actions>
                    <nb-action icon="edit-outline" (click)="viewEdit.toggle()" title="Edit Summary"></nb-action>
                </nb-actions>
            </div>
        </div>
        <div style="padding-bottom:0.875rem;">{{displayedValue}}</div>
    </div>
    <div class="edit view-edit-hide">
        <h6>
            Edit Status
        </h6>
        <ng-container *ngFor="let formField of subFormFields">
            <ubs-ofbiz-form-field [formField]="formField" [form]="form"></ubs-ofbiz-form-field>
        </ng-container>
        <form [formGroup]="form">
            <input type="text" nbInput fullWidth placeholder="StatusId" formControlName="statusId"/>
        </form>
        <div style="display:flex;flex-direction: row;padding: 0.5rem 1rem;">
            <span>&nbsp;</span>
            <div style="flex:1;display:flex;justify-content:end">
                <ng-container *ngIf="hasChanged;else nochanges">
                    <nb-actions>
                        <nb-action icon="close-outline" (click)="viewEdit.toggle()" title="Edit Status"></nb-action>
                        <nb-action icon="refresh-outline" (click)="reset()" title="reset"></nb-action>
                        <nb-action icon="checkmark-outline" (click)="submit()" title="Submit Status"></nb-action>
                    </nb-actions>
                </ng-container>
                <ng-template #nochanges>
                    <nb-actions>
                        <nb-action icon="close-outline" (click)="viewEdit.toggle()" title="Close Edit"></nb-action>
                    </nb-actions>
                </ng-template>
            </div>
        </div>
    </div>
</div>
